import JiraTypes from './types';

export default {
  [JiraTypes.JIRA_PROJECTS]: (state, { data, status }) => {
    state.jiraProjects = { data, status };
  },
  [JiraTypes.JIRA_PROJECTS_UPDATE]: (state, { data, status }) => {
    state.jiraProjectsUpdate = { data, status };
  },
  [JiraTypes.JIRA_PROJECTS_PUSH_UPDATE]: (state, { data, status }) => {
    state.jiraProjectsPushUpdate = { data, status };
  },
  [JiraTypes.JIRA_PROJECT_ISSUES]: (state, { data, status }) => {
    state.jiraProjectIssues = { data, status };
  },
  [JiraTypes.JIRA_ISSUES]: (state, { data, status }) => {
    state.jiraIssues = { data, status };
  },
  [JiraTypes.JIRA_ISSUES_SEARCH]: (state, { data, status }) => {
    state.jiraIssuesSearch = { data, status };
  },
  [JiraTypes.JIRA_ISSUE_DATA]: (state, { data, status }) => {
    state.jiraIssueData = { data, status };
  },
  [JiraTypes.JIRA_PROJECTS_RESET_ENTITIES]: (state, { data, status }) => {
    state.jiraProjectsResetEntities = { data, status };
  },
};
